"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceFile = exports.writeObligationValues = exports.roleValues = void 0;
exports.roleValues = ["ROLE_ANONYMOUS", "ROLE_USER", "ROLE_EDITOR", "ROLE_ADMIN"];
var _writeObligationValues = ["NONE", "OPTIONAL", "RECOMMENDED", "MANDATORY"];
exports.writeObligationValues = _writeObligationValues;
/** @internal */
var SourceFile;
(function (SourceFile) {
    SourceFile.roleKeys = ["guest", "user", "owner", "editor", "admin"];
    SourceFile.writeObligationValues = _writeObligationValues;
})(SourceFile = exports.SourceFile || (exports.SourceFile = {}));
